import type { MtbTrailBuild, MtbTrailCategory, MtbTrailCharacter, MtbTrailFeature } from "~/lib/api";

export const CATEGORY_LABELS: Record<MtbTrailCategory, string> = {
  xc: "XC",
  enduro: "Enduro",
  downhill: "Downhill",
  freeride: "Freeride",
  "dirt-jump": "Dirt Jump",
};

export const CHARACTER_LABELS: Record<MtbTrailCharacter, string> = {
  flow: "Flow",
  tech: "Tech",
  jumps: "Jumps",
  drops: "Drops",
  steep: "Steep",
  rocky: "Rocky",
  rooty: "Rooty",
  loose: "Loose",
};

export const FEATURE_LABELS: Record<MtbTrailFeature, string> = {
  "rock-gardens": "Rock Gardens",
  berms: "Berms",
  rollers: "Rollers",
  gaps: "Gaps",
  skinnies: "Skinnies",
  northshore: "Northshore",
  switchbacks: "Switchbacks",
};

export const BUILD_LABELS: Record<MtbTrailBuild, string> = {
  "old-school": "Old School",
  "hand-built": "Hand-built",
  "machine-built": "Machine-built",
};
